// extracted by mini-css-extract-plugin
module.exports = {"loader":"lazyLoading_loader__onp7N","spin":"lazyLoading_spin__3ETt4"};